import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { AlertComponent } from '@pedix-workspace/angular-ui-alert';
import { IconAlertComponent } from '@pedix-workspace/angular-ui-icons';
import {
  PurchaseRestrictionKind,
  PurchaseSelectionViolation,
  formatRestrictionNames,
} from '@pedix-workspace/utils';

const RESTRICTION_MESSAGE_KEYS: Record<PurchaseRestrictionKind, string> = {
  shipping: 'endOrder.restrictionOnlyShipping',
  payment: 'endOrder.restrictionOnlyPayment',
  both: 'endOrder.restrictionOnlyBoth',
};

@Component({
  selector: 'pxw-product-restriction-alert',
  templateUrl: './product-restriction-alert.component.html',
  styleUrls: ['./product-restriction-alert.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoDirective, AlertComponent, IconAlertComponent],
})
export class ProductRestrictionAlertComponent {
  private t = inject(TranslocoService);
  private activeLang = toSignal(this.t.langChanges$, { initialValue: this.t.getActiveLang() });

  readonly violations = input.required<PurchaseSelectionViolation[]>();
  readonly actionText = input.required<string>();

  readonly rows = computed(() => {
    const orLabel = this.t.translate('global.or', {}, this.activeLang());

    return this.violations().map(violation => ({
      productId: violation.productId,
      product: violation.product,
      messageKey: RESTRICTION_MESSAGE_KEYS[violation.kind],
      shipping: formatRestrictionNames(violation.shipping ?? [], orLabel),
      payment: formatRestrictionNames(violation.payment ?? [], orLabel),
    }));
  });
}
